__turbopack_context__.v({
  "className": "playfair_display_28698f53-module__8Lx67q__className",
  "variable": "playfair_display_28698f53-module__8Lx67q__variable",
});
